import axios from "axios";

const PrintType = async (parentId) => {
  try {
    const result = await axios.get(
      `${process.env.REACT_APP_HOST}commons/printTypes`
    );

    return result;
  } catch (error) {
    return false;
  }
};

export default PrintType;
